import React from 'react';

const partners = [
    'ariat',
    'boss-equestrian',
    'busse',
    'deckenservice-huber',
    'effol',
    'felix-buehler',
    'frey',
    'horseware',
    'hypona',
    'kingsland',
    'marstall',
    'pikeur',
    'soulhorse',
];

export default () => (
    <div>
        {partners.map(partner => (
            <img
                src={`https://horsedeal.imgix.net/static/landingPageFlipAndWin/partners/flip-and-win-${partner}.svg`}
                alt="partner-image"
            />
        ))}
    </div>
);
